import { AbstractControl, ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';

const ACCEPTED_DATE_FORMATS = ['MM/dd/yyyy', 'yyyy-MM-dd'];

function hasAcceptedDateFormat(value: string): boolean {
  return ACCEPTED_DATE_FORMATS.some(format => DateTime.fromFormat(value, format).isValid);
}

export function dateFormatValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return isNaN(value.getTime()) ? { dateInvalid: true } : null;
    }

    if (typeof value !== 'string') {
      return { dateInvalid: true };
    }

    const isValid = hasAcceptedDateFormat(value);
    return isValid ? null : { dateInvalid: true };
  };
}
